import { MsalProvider } from "@azure/msal-react";
import { CssBaseline } from "@mui/material";
import { LicenseInfo } from "@mui/x-license-pro";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import axios from "axios";
import { SnackbarDefault } from "components";
import { PageLoading } from "components/PageLoading/PageLoading";
import { MUILicenseKey } from "configs";
import { queryClient } from "configs/react-query";
import {
  AppNavigationProvider,
  DialogServiceProvider,
  UseAlert,
  UseConfirm,
  alert,
} from "contexts";
import AppThemeProvider from "contexts/Theme/provider";
import { AppInitializer } from "libs";
import { AuthLoader } from "libs/auth";
import { msalInstance } from "libs/msal";
import { SnackbarProvider } from "notistack";
import queryString from "query-string";
import { ErrorBoundary } from "react-error-boundary";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { AppRoutes } from "routes";
import store, { persistor } from "stores";
import { i18n } from "translations";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import "../index.scss";
import storage from "utils/storage";

if (process.env.NODE_ENV === "production" && MUILicenseKey) {
  LicenseInfo.setLicenseKey(MUILicenseKey);
}
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
// axios.defaults.headers.common.Authorization = `Bearer ${storage.getToken()}`;
axios.interceptors.request.use(function (config) {
  const token = store.getState();
  config.headers.Authorization =  `Bearer ${storage.getToken()}`;
   
  return config;
});

const onErrorHandler = () => {
  alert({
    title: i18n.t("Oops! Something went wrong"),
    content: i18n.t("Please reload and try again!"),
    cancelLabel: i18n.t("Reload"),
    disableCloseOnBackdropAndEscape: true,
  })
    .then(() => window.location.reload())
    .catch(() => {});
};
// console.log(msalInstance, "msalInstance");
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <MsalProvider instance={msalInstance}>
            <AuthLoader renderLoading={() => <PageLoading />}>
              <AppThemeProvider showModeTool>
                <BrowserRouter>
                  <AppNavigationProvider>
                    <DialogServiceProvider>
                      <ErrorBoundary
                        fallbackRender={() => null}
                        onError={onErrorHandler}
                      >
                        <SnackbarProvider
                          maxSnack={3}
                          autoHideDuration={3000}
                          Components={{ default: SnackbarDefault }}
                        >
                          <CssBaseline />
                          <ReactQueryDevtools />
                          <AppInitializer />
                          {/* <AzureInitializer /> */}
                          <UseConfirm />
                          <UseAlert />
                          <QueryParamProvider
                            adapter={ReactRouter6Adapter}
                            options={{
                              searchStringToObject: queryString.parse,
                              objectToSearchString: queryString.stringify,
                            }}
                          >
                            <AppRoutes />
                          </QueryParamProvider>
                        </SnackbarProvider>
                      </ErrorBoundary>
                    </DialogServiceProvider>
                  </AppNavigationProvider>
                </BrowserRouter>
              </AppThemeProvider>
            </AuthLoader>
          </MsalProvider>
        </PersistGate>
      </ReduxProvider>
    </QueryClientProvider>
  );
}

export default App;
